export const queryKeys = {
  ME: "me",
  ME_CAMPS: "me-camps",
  ME_CAMPING_STYLES: "me-campingStyles",
  PRODUCTS: "products",
  COUPONS: "coupons",
  AUTOMATED_MESSAGES: "automated-messages",
  RESERVATION_PREVIEWS: "reservation-previews",
  ORDER: "order",
  HISTORY: "history",
  RESERVATION: "reservation",
  CAMPER: "camper",
  CAMP: "camp",
  ORDER_INVOICE: "order-invoice",
}
